/**
 * This middleware handles promo codes to be injected in
 * the POST request when a user is created.
 */
import { getCookie, setCookie } from 'stash/utils/cookies';
import { POST_USER_REQUEST } from 'stash/actions/api/user';
import { STASH_INIT } from 'stash/actions/init';
import { getURLParam } from 'stash/utils';

export const PROMO_COOKIE_NAME = 'stashPromoCode';
export const PROMO_PARAM_NAME = 'stash_code';
const MAX_COOKIE_AGE = 1000 * 60 * 60 * 24 * 15; // 15 days

const promo = () => (next) => (action) => {
	// Persist promocode in a cookie on load.
	if (action.type === STASH_INIT) {
		if (getURLParam(PROMO_PARAM_NAME)) {
			setCookie(PROMO_COOKIE_NAME, getURLParam(PROMO_PARAM_NAME), {
				domain: '.stash.com',
				maxAge: MAX_COOKIE_AGE,
			});
		}
	}

	// Get promocode from cookies on a new user POST.
	if (action.type === POST_USER_REQUEST) {
		if (getCookie(PROMO_COOKIE_NAME)) {
			return next({
				...action,
				request: {
					...action.request,
					body: {
						...action.request.body,
						referral_source_code: getCookie(PROMO_COOKIE_NAME),
					},
				},
			});
		}
	}

	return next(action);
};

export default promo;
